<template>
<div>
  <PageAppBar>{{video.title}}</PageAppBar>
  <div class="page-content header-clear-small">
    <section>
      <youtube :video-id="video_id" @ready="1" @playing="1" :player-width="width" :player-height="width*9/16" :player-vars="{autoplay: 1}"></youtube>
    </section>

  </div>
  <FooterBar></FooterBar>
</div>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed'
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
export default {
  components: {FooterBar, PageAppBar},
  data(){
    return {
      video_id: getIdFromURL(this.$store.getters.video.link),
      video: this.$store.getters.video,
      width: (window.innerWidth > 0) ? window.innerWidth : screen.width
    }
  },
}
</script>

<style scoped>

</style>